export const RouteUrls = {
  Sensor: "sensor-api",
  DoorEventsHistory: "sensor-api/events-history",

  // floor map
  FloorMapAddDevice: "sensor-api/floor-map",
  DeviceWithSensor: "sensor-api/get-device-sensor",
  getFloorList: "floor",
  Site: "sites",

  DeviceThresholdValues: "device-threshold-values",
  UserSensorDeviceRulesDetails: "user-sensor-device-rules-details1",
  OptaDevices: "/opta-devices",
  NotificationConfig:"/notification-config",
  NotificationTest:"/notification-config/test",
  sessions:"/sessions",
  DeviceTrackerHistory:"/sessions/device-history",
  PatientSessionsWithDoctors:"/sessions/patient-sessions/doctors",
  TempPatientSessionsWithDoctors:"/sessions/patient-sessions/t/doctors",

  MinewGoods:"/minew/goods",
  MinewDynamicFields:"/minew/dynamic-fields",
  MinewProduct:"/minew/product",
  MinewUpdateProduct: "/minew/product/update",
};
